import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import {
    Button,
    Tooltip,
    Spin,
    message,
    Row,
    Col,
    Card,
    Typography,
} from "antd";
import {
    ForwardOutlined,
    BackwardOutlined,
    ArrowLeftOutlined,
    TruckOutlined,
} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import InvoicesTable from "./InvoicesTable";
import InvoicesTableAssign from "./InvoicesTableVehicle";

const { Title } = Typography;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS,
});

function EditVehicleAssignment() {
    const invoicesTableRef = useRef();
    const invoicesTableRefTabla2 = useRef();

    const {t} = useTranslation();
    const [error, setError] = useState(null);
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState(t("global.loading"));
    const [messageApi, contextHolder] = message.useMessage();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowKeysX, setSelectedRowKeysX] = useState([]);
    const [sessionDataStorage, setSessionDataStorage] = useState([]);
    const [datosVehiculo, setDatosVehiculo] = useState([]);

    const headers = {
        accept: "*/*",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
        "Content-Type": "application/json",
    };

    useEffect(() => {
        let dataStorage = JSON.parse(sessionStorage.getItem("sessionStorage"));
        let datos =
            dataStorage.matricula +
            " / " +
            dataStorage.tipo_vehiculo +
            " / " +
            dataStorage.fullname;
        setDatosVehiculo(datos);
        setSessionDataStorage(dataStorage);
    }, []);


    const asignarPaquetes = () => {
        return new Promise((resolve, reject) => {
            setSpinTitle(t("global.processing_data"));
            setSpinning(true);

            Axios.post(
                "sd/asignarPaqueteVehiculo",
                {
                    idvehiculo: sessionDataStorage.idvehiculo,
                    idinvoice: selectedRowKeys,
                },
                {
                    headers: headers,
                }
            )
                .then((response) => {
                    setSpinning(false);
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message || t('assignment.assign_success'),
                            duration: 2.5,
                        });
                        resolve(true);
                    } else {
                        const errorMessage = response.data.message || response.data.error || t('assignment.assign_error');
                        messageApi.open({
                            type: 'error',
                            content: errorMessage,
                            duration: 3,
                        });
                        reject(errorMessage);
                    }
                })
                .catch((error) => {
                    setSpinning(false);
                    let errorMessage = t('assignment.assign_error');
                    if (error.response?.data) {
                        errorMessage = error.response.data.message || error.response.data.error || errorMessage;
                    }
                    messageApi.open({
                        type: 'error',
                        content: errorMessage,
                        duration: 3,
                    });
                    reject(errorMessage);
                });
        });
    };

    const handleButtonClick = async () => {
        try {
            await asignarPaquetes();
        } finally {
            if (invoicesTableRef.current) {
                invoicesTableRef.current.recargar();
            }
            if (invoicesTableRefTabla2.current) {
                invoicesTableRefTabla2.current.recargar();
            }
        }
    };

    const deletePaquetes = () => {
        return new Promise((resolve, reject) => {
            setSpinTitle(t("global.processing_data"));
            setSpinning(true);

            Axios.post(
                "sd/deletePaqueteVehiculo",
                {
                    idinvoice: selectedRowKeysX,
                    idvehiculo: sessionDataStorage.idvehiculo,
                },
                {
                    headers: headers,
                }
            )
                .then((response) => {
                    setSpinning(false);
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message || t('assignment.unassign_success'),
                            duration: 2.5,
                        });
                        resolve(true);
                    } else {
                        const errorMessage = response.data.message || response.data.error || t('assignment.unassign_error');
                        messageApi.open({
                            type: 'error',
                            content: errorMessage,
                            duration: 3,
                        });
                        reject(errorMessage);
                    }
                })
                .catch((error) => {
                    setSpinning(false);
                    let errorMessage = t('assignment.unassign_error');
                    if (error.response?.data) {
                        errorMessage = error.response.data.message || error.response.data.error || errorMessage;
                    }
                    messageApi.open({
                        type: 'error',
                        content: errorMessage,
                        duration: 3,
                    });
                    reject(errorMessage);
                });
        });
    };

    const handleButtonClickX = async () => {
        try {
            await deletePaquetes();
        } finally {
            if (invoicesTableRef.current) {
                invoicesTableRef.current.recargar();
            }
            if (invoicesTableRefTabla2.current) {
                invoicesTableRefTabla2.current.recargar();
            }
        }
    };

    const handleRowSelectionChange = (keys) => {
        setSelectedRowKeys(keys);
    };
    const handleRowSelectionChangeX = (keys) => {
        setSelectedRowKeysX(keys);
    };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "24px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "1600px",
                    margin: "0 auto"
                }}>
                    {/* Header */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px'
                            }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '50%',
                                    width: '48px',
                                    height: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px'
                                }}>
                                    <TruckOutlined />
                                </div>
                                <div>
                                    <Title level={2} style={{
                                        color: 'white',
                                        margin: 0,
                                        fontSize: '24px'
                                    }}>
                                        {t("assignment.title")}
                                    </Title>
                                    <p style={{
                                        color: 'rgba(255,255,255,0.8)',
                                        margin: 0,
                                        fontSize: '14px'
                                    }}>
                                        {datosVehiculo}
                                    </p>
                                </div>
                            </div>
                            <Link to="/assignment">
                                <Tooltip title={t("assignment.back")}>
                                    <Button
                                        icon={<ArrowLeftOutlined />}
                                        size="large"
                                        style={{
                                            background: 'rgba(255,255,255,0.2)',
                                            borderColor: 'rgba(255,255,255,0.3)',
                                            color: 'white',
                                            fontWeight: '500'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = 'rgba(255,255,255,0.3)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = 'rgba(255,255,255,0.2)';
                                        }}
                                    >
                                        Volver
                                    </Button>
                                </Tooltip>
                            </Link>
                        </div>
                    </div>

                    {/* Main Content */}
                    <Card style={{
                        borderRadius: '0 0 12px 12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        border: 'none',
                        minHeight: '70vh'
                    }}>
                        {contextHolder}

                        <Row gutter={[24, 24]} style={{ height: '100%' }}>
                            {/* Facturas Pendientes */}
                            <Col xs={24} lg={11}>
                                <Card style={{
                                    borderRadius: '12px',
                                    border: '1px solid #e0e6ff',
                                    height: '100%'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        marginBottom: '16px'
                                    }}>
                                        <Title level={4} style={{
                                            color: '#253289',
                                            margin: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            📦 {t("assignment.subtitle_assign_pending")}
                                        </Title>
                                    </div>

                                    {error && <div style={{ color: '#ff4d4f', marginBottom: '16px' }}>Error: {error}</div>}

                                    <div style={{
                                        overflowX: 'auto',
                                        overflowY: 'auto',
                                        maxHeight: '500px',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: '8px'
                                    }}>
                                        <InvoicesTable
                                            ref={invoicesTableRef}
                                            onRowSelectionChange={handleRowSelectionChange}
                                            sessionDataStorage={sessionDataStorage}
                                            asignada={0}
                                            t={t}
                                        />
                                    </div>
                                </Card>
                            </Col>

                            {/* Control Buttons */}
                            <Col xs={24} lg={2}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100%',
                                    gap: '16px'
                                }}>
                                    <Tooltip title="Asignar paquetes seleccionados">
                                        <Button
                                            type="primary"
                                            onClick={handleButtonClick}
                                            icon={<ForwardOutlined />}
                                            size="large"
                                            disabled={selectedRowKeys.length === 0}
                                            style={{
                                                background: selectedRowKeys.length > 0
                                                    ? 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)'
                                                    : '#d9d9d9',
                                                borderColor: selectedRowKeys.length > 0 ? '#253289' : '#d9d9d9',
                                                height: '50px',
                                                width: '50px',
                                                borderRadius: '8px',
                                                fontWeight: '500',
                                                color: selectedRowKeys.length > 0 ? 'white' : '#000000',
                                                boxShadow: selectedRowKeys.length > 0
                                                    ? '0 2px 8px rgba(37, 50, 137, 0.3)'
                                                    : 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        />
                                    </Tooltip>

                                    <div style={{
                                        width: '2px',
                                        height: '40px',
                                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                        borderRadius: '1px'
                                    }} />

                                    <Tooltip title="Quitar paquetes seleccionados">
                                        <Button
                                            type="primary"
                                            onClick={handleButtonClickX}
                                            icon={<BackwardOutlined />}
                                            size="large"
                                            disabled={selectedRowKeysX.length === 0}
                                            style={{
                                                background: selectedRowKeysX.length > 0
                                                    ? 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)'
                                                    : '#d9d9d9',
                                                borderColor: selectedRowKeysX.length > 0 ? '#ff4d4f' : '#d9d9d9',
                                                height: '50px',
                                                width: '50px',
                                                borderRadius: '8px',
                                                fontWeight: '500',
                                                color: selectedRowKeysX.length > 0 ? 'white' : '#000000',
                                                boxShadow: selectedRowKeysX.length > 0
                                                    ? '0 2px 8px rgba(255, 77, 79, 0.3)'
                                                    : 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        />
                                    </Tooltip>
                                </div>
                            </Col>

                            {/* Facturas Asignadas */}
                            <Col xs={24} lg={11}>
                                <Card style={{
                                    borderRadius: '12px',
                                    border: '1px solid #e0e6ff',
                                    height: '100%'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        marginBottom: '16px'
                                    }}>
                                        <Title level={4} style={{
                                            color: '#253289',
                                            margin: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            🚚 {t("assignment.subtitle_assign")}
                                        </Title>
                                    </div>

                                    {error && <div style={{ color: '#ff4d4f', marginBottom: '16px' }}>Error: {error}</div>}

                                    <div style={{
                                        overflowX: 'auto',
                                        overflowY: 'auto',
                                        maxHeight: '500px',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: '8px'
                                    }}>
                                        <InvoicesTableAssign
                                            ref={invoicesTableRefTabla2}
                                            onRowSelectionChange={handleRowSelectionChangeX}
                                            sessionDataStorage={sessionDataStorage}
                                            asignada={1}
                                            t={t}
                                        />
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </Spin>
        </div>
    );
}

export default EditVehicleAssignment;
